import React, { useState } from 'react';
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Button,
  Box
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import { Student } from '@/types';
import { StudentDetailsModal } from './StudentDetailsModal';

interface AttentionRequiredProps {
  students: Student[];
}

export const AttentionRequired: React.FC<AttentionRequiredProps> = ({ students }) => {
  const [selectedStudent, setSelectedStudent] = useState<Student | null>(null);

  const atRiskStudents = students
    .filter(s => s.attendanceRate < 90)
    .sort((a, b) => a.attendanceRate - b.attendanceRate)
    .slice(0, 10);

  const getRiskLevel = (rate: number) => {
    if (rate < 85) return { label: 'Critical', color: 'error' };
    if (rate < 90) return { label: 'At Risk', color: 'warning' };
    return { label: 'Good', color: 'success' };
  };

  const handleViewDetails = (student: Student) => {
    setSelectedStudent(student);
  };

  return (
    <>
      <Paper sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
          <WarningIcon color="warning" />
          <Typography variant="h6">
            Students Requiring Attention
          </Typography>
        </Box>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Student</TableCell>
                <TableCell>Grade</TableCell>
                <TableCell>Attendance Rate</TableCell>
                <TableCell>Days Absent</TableCell>
                <TableCell>Risk Level</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {atRiskStudents.map((student) => {
                const risk = getRiskLevel(student.attendanceRate);
                
                return (
                  <TableRow key={student.id}>
                    <TableCell>
                      {student.firstName} {student.lastName}
                    </TableCell>
                    <TableCell>Grade {student.grade}</TableCell>
                    <TableCell>{student.attendanceRate}%</TableCell>
                    <TableCell>{student.daysAbsent}</TableCell>
                    <TableCell>
                      <Chip
                        label={risk.label}
                        color={risk.color as any}
                        size="small"
                      />
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => handleViewDetails(student)}
                      >
                        View Details
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <StudentDetailsModal
        student={selectedStudent}
        open={!!selectedStudent}
        onClose={() => setSelectedStudent(null)}
      />
    </>
  );
};